import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './levelProgress.module.scss';

interface LevelProgressProps {
  levelName: string;
  progressPercent: number;
  pointsUntilNext: string;
}

const LevelProgress: React.FC<LevelProgressProps> = ({
  levelName,
  progressPercent,
  pointsUntilNext,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.progressSection}>
      <div className={styles.progressLabels}>
        <span>
          {t('rewards.levelProgress.yourProgress')}{' '}
          <span className={styles.progressValue}>{progressPercent}%</span>
        </span>
        <span>
          {levelName}: <span className={styles.progressValue}>{pointsUntilNext}</span>{' '}
          {pointsUntilNext && (
            <span className={styles.points}>{t('rewards.levelProgress.points')}</span>
          )}
        </span>
      </div>
      <div className={styles.progressBar}>
        <div className={styles.progressFill} style={{ width: `${progressPercent}%` }}></div>
      </div>
    </div>
  );
};

export default LevelProgress;
